import hexToRgb from 'pretty-easy-hex-to-rgb';
import { lighten } from 'polished';
import styled from 'styled-components';
import React from 'react';
import SVG from 'react-inlinesvg';

import colors from 'shared-assets/lib/colors';
import styles from 'shared-assets/lib/styles';
import PropTypes from 'prop-types';

const CheckboxInput = styled.input`
  position: absolute;
  opacity: 0;
  cursor: pointer;
  top: 0;
  left: 0;
  margin: 0;
  height: 1rem;
  width: 1rem;
`;

CheckboxInput.defaultProps = {
  type: 'checkbox',
};

CheckboxInput.propTypes = {
  type: PropTypes.oneOf(['checkbox', 'radio']), // radio was added to support CheckboxAsRadio component
};

const CheckboxContainer = styled.label`
  display: flex;
  position: relative;
  cursor: pointer;
  font-size: 1rem;
  user-select: none;
  width: 1rem;
  height: 1rem;

  &:hover input ~ span {
    background-color: rgba(
      ${hexToRgb(lighten(0.1, colors.primary)).join(', ')},
      0.08
    );
  }

  input:checked ~ span {
    background-color: ${colors.checkbox};
    border: none;
  }

  input:checked ~ span svg {
    display: block;
  }

  input:not(:checked) ~ span svg {
    display: none;
  }

  /** Disabled styling for the checkbox **/
  input:disabled ~ span {
    background-color: rgba(${colors.secondaryRGB.join(', ')}, 0.1);
    border-color: rgba(${colors.secondaryRGB.join(', ')}, 0.2);
    cursor: not-allowed;
  }

  /** Disabled styling for the checkbox when checked **/
  input:checked:disabled ~ span {
    border-color: ${colors.checkboxDisabled};
    background-color: ${colors.checkboxDisabled};
  }

  .bar {
    display: none;
  }

  span svg {
    position: absolute;
    width: 0.7rem;
    height: 0.7rem;
    top: 0.15rem;
    left: 0.16rem;
  }

  span svg path {
    fill: #fff;
  }

  input:indeterminate ~ span {
    background-color: ${colors.checkbox}
    border: none;

    svg {
      display: block;
      width: 0.625rem;
    }
    .bar {
      display: block;
    }
    .checkmark {
      display: none;
    }
  }
`;

const CheckboxSpan = styled.span`
  position: absolute;
  top: 0;
  left: 0;
  width: 1rem;
  height: 1rem;
  border-radius: ${styles.borderRadius};
  border: ${styles.border.default};
`;

const Checkbox = React.forwardRef((props, ref) => (
  <CheckboxContainer>
    <CheckboxInput ref={ref} {...props} />
    <CheckboxSpan>
      <SVG className="checkmark" src="/static/assets/icons/check-mark.svg" />
      <SVG className="bar" src="/static/assets/icons/bar.svg" />
    </CheckboxSpan>
  </CheckboxContainer>
));

Checkbox.displayName = 'Checkbox';

Checkbox.defaultProps = {
  type: 'checkbox',
  value: undefined,
};

Checkbox.propTypes = {
  type: PropTypes.oneOf(['checkbox', 'radio']), // radio was added to support CheckboxAsRadio component
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default Checkbox;
